import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6aaf5edb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "img animate" }
const _hoisted_2 = { width: "350" }


import router from '@/router'
import useWindowWidth from '@/composables/useWindowWidth'



export default /*#__PURE__*/_defineComponent({
  __name: 'NewsItemCard',
  props: ['title', 'description', 'img', 'route'],
  setup(__props) {

const props = __props
const {windowWidth} = useWindowWidth()
const handleRoute = () => {
    router.push({name: props.route})
}

return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({box:true, card:_unref(windowWidth)>950, animate:true, cardmobile:_unref(windowWidth)<=950})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
        [_directive_lazy, { src: props.img, loading: '../../../img/lms/loading.png'}]
      ])
    ]),
    _createElementVNode("h3", null, _toDisplayString(props.title), 1),
    _createElementVNode("p", null, _toDisplayString(props.description), 1),
    _createElementVNode("button", {
      class: "primary-button",
      onClick: handleRoute
    }, "Ver más")
  ], 2))
}
}

})